(function(){
    'use strict';
    angular.module('Services').factory('isEqualsService', isEqualsService);
    isEqualsService.$inject = ['toastr', '$timeout'];

    function isEqualsService(toastr, $timeout) {
        let service = this;
        service.isEquals = isEquals;

        /**
         * Check if obj1 has the same value with obj2
         * 
         * @param { obj } paramsObj  object that holds all the parameter values
         * 
         * @return { boolean }
         */
        function isEquals(paramsObj) { 
            let val1 = paramsObj.val1; // any type of value
            let val2 = paramsObj.val2; // any type of value
            let errorMsg = paramsObj.errorMsg; // should be a string;
            let formField = paramsObj.formField; // should be formName.fieldName
            let valid = angular.equals(val1, val2) ? true : false;
            let errNameOveride = paramsObj.errNameOveride ? paramsObj.errNameOveride : 'isEquals'; // errorName overide

            formField.$setValidity(errNameOveride, valid);
            toastr.clear();
            if(!valid) toastr.warning(errorMsg, 'Form Errors');
            return valid;
        }

        return service;
    }
})()


// WEBPACK FOOTER //
// ./js/services/form-validations/isEqual.js